/**
 * withBackInStockNotifications
 * HOC for wrapping the provided component with UserProvider
 */

import React from 'react'

import BackInStockNotificationsProvider from './back-in-stock-notifications-provider'

const withBackInStockNotifications = WrappedComponent => props => (
  <BackInStockNotificationsProvider>
    <WrappedComponent {...props} />
  </BackInStockNotificationsProvider>
);

export default withBackInStockNotifications;

